<div class="unscheduled-events-wrapper" *ngIf="hasHeaderContent()">
  <!-- All untimed events in one shared chip row — no special rows per entity type. Matches Flutter. -->
  <div class="unscheduled-events" *ngIf="unscheduledEvents().length > 0">
    <div class="unscheduled-event" (click)="handleUnScheduledEvent(event)"
      *ngFor="let event of unscheduledEvents() | slice:0:unscheduledVisibleCount()" role="button"
      [ngClass]="{'calendarIntegration': event.entityType === 'calendarIntegration'}"
      [style.width]="getEventTileWidth(unscheduledEventsDisplayCount())"
      [style.flex]="unscheduledEventsDisplayCount() > 1 ? '0 0 auto' : '1'" [style.min-width]="'0'"
      [style.max-width]="getEventTileWidth(unscheduledEventsDisplayCount())">
      <div class="event-title bedge-flex-center">
        <span class="event-title-text">{{ truncateUnscheduledTitle(event.sortTitle) }}</span>
      </div>
      <ng-container *ngIf="event.entityType !== 'calendarIntegration' && event.entityType !== 'moneyTracker'">
        <app-svg *ngIf="event.isCompleted"
          name="calenderViewCompleted"
          [color]="ss.theme().color12"></app-svg>
        <div *ngIf="!event.isCompleted"
          class="event-checkmark">
        </div>
      </ng-container>
    </div>
    <div class="unscheduled-view-more" *ngIf="unscheduledEvents().length > maxEventsPerRow" role="button"
      (click)="viewMoreEntities('other')" [style.width]="getEventTileWidth(unscheduledEventsDisplayCount())"
      [style.flex]="'0 0 auto'" [style.min-width]="'0'"
      [style.max-width]="getEventTileWidth(unscheduledEventsDisplayCount())">
      <div class="event-title text-12-400 color-7">{{ ss.t('common_collapsedNumberOfEntities', { count:
        (unscheduledEvents().length - unscheduledVisibleCount()).toString() }) }}</div>
    </div>
  </div>
</div>

<div class="multi-day-span-bars" *ngIf="multiDayEndAtEvents().length > 0">
  <div class="multi-day-span-bar" *ngFor="let event of multiDayEndAtEvents()" (click)="handleUnScheduledEvent(event)"
    role="button" [ngClass]="{
      'span-start': event.dayIndex === 0,
      'span-end': event.dayIndex === event.totalDays - 1,
      'span-middle': event.dayIndex !== 0 && event.dayIndex !== event.totalDays - 1,
      'calendarIntegration': event.entityType === 'calendarIntegration'
    }">
    <span class="event-title-text">{{ event.sortTitle }} {{ event.dayIndex + 1 }}/{{ event.totalDays }}</span>
  </div>
</div>

<mwl-calendar-day-view class="today-cal-day-view" [viewDate]="viewDate" [events]="processedEvents()"
  [eventTemplate]="customEventTemplate">
</mwl-calendar-day-view>

<ng-template #customEventTemplate let-weekEvent="weekEvent">
  <!-- Regular events -->
  <div *ngIf="weekEvent.event.meta.entity !== 'viewMore'" class="cal-event flex items-center"
    (click)="handleScheduledEvent(weekEvent.event)" role="button" [ngClass]="weekEvent.event.meta.entity">
    <div class="event-title bedge-flex-center text-12-400"
      [ngClass]="weekEvent.event.meta.entity === 'calendarIntegration' ? 'color-8-important' : 'color-12'">
      <app-me-user-avatar [uid]="weekEvent.event.uid" size="small" class="ri-me-2 focus-event-badge"
        *ngIf="weekEvent.event.uid !== cc.user.uid"></app-me-user-avatar>
      <span class="event-title-text">{{ truncateScheduledTitle(weekEvent.event.sortTitle, weekEvent.event.uid !==
        cc.user.uid) }}</span>
      @if(weekEvent.event.meta.entity === 'focus'){
      <span class="text-12-400 color-12 focus-event-score">{{ weekEvent.event.meta.score }}</span>
      }
    </div>
    @if(weekEvent.event.meta.entity !== 'focus' && weekEvent.event.meta.entity !== 'moneyTracker'){
    <div class="event-check-progress"
      *ngIf="weekEvent.event.meta.entity === 'habit' && weekEvent.event.meta.percentage && weekEvent.event.meta.percentage < 100; else calendarCheckmark"
      [style.background]="getProgressBg(weekEvent.event.meta.percentage || 0)"></div>

    <ng-template #calendarCheckmark>
      <div class="event-checkmark"
        *ngIf="weekEvent.event.cssClass !== 'skipped' && weekEvent.event.cssClass !== 'completed'"
        [ngClass]="{'invalid': weekEvent.event.cssClass === 'missed', 'hasvalue': weekEvent.event.cssClass === 'draft', 'none': weekEvent.event.meta.entity === 'calendarIntegration'}">
      </div>
      <app-svg *ngIf="weekEvent.event.cssClass === 'skipped' || weekEvent.event.cssClass === 'completed'"
        [name]="weekEvent.event.cssClass === 'skipped' ? 'calenderViewSkipped' : 'calenderViewCompleted'"
        [color]="ss.theme().color12"></app-svg>
    </ng-template>
    }
  </div>

  <!-- View More event -->
  <div *ngIf="weekEvent.event.meta.entity === 'viewMore'" class="cal-event flex items-center"
    (click)="viewMoreScheduledEvents(weekEvent.event.meta.hiddenEvents, weekEvent.event.meta.timeKey)" role="button">
    <div class="event-title text-12-400 color-7">
      {{ weekEvent.event.sortTitle }}
    </div>
  </div>
</ng-template>